var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonCloudOffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.797 12.136a8.871 8.871 0 0 0-.98-2.543l6.179-6.179L28.583 2 2.001 28.587 3.415 30l4.999-5h15.083a6.496 6.496 0 0 0 1.3-12.864zM23.497 23H10.413L22.34 11.072c.307.655.51 1.354.6 2.071l.1.812.814.064A4.497 4.497 0 0 1 23.497 23zm-19.2.449 1.431-1.431a4.477 4.477 0 0 1 2.416-7.999l.816-.064.099-.812a6.987 6.987 0 0 1 10.628-5.086l1.442-1.443A8.983 8.983 0 0 0 7.2 12.136 6.49 6.49 0 0 0 4.297 23.45v-.001z",
    fill: "#979797",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCloudOffline);
export default __webpack_public_path__ + "static/media/carbon-cloud-offline.a6265c2adf1706031700bd6d1636670e.svg";
export { ForwardRef as ReactComponent };